import React from "react";

/**
 * This component is the layout that is used for Pages Router pages, in
 * conjunction with the Layout component, which is used for pages using
 * both the Pages and App Router. All of the functionality here should
 * be migrated to the Layout component to bring parity between the two
 * routers, once it is possible to do so.
 */
const PagesRouterLayout: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  return <main>{children}</main>;
};

export default PagesRouterLayout;
